import { useState } from "react";
import { Button, Icon } from "react-bulma-components";
import { useTranslation } from "react-i18next";
import { ModalProps } from "../ModalManager";

export type ShareBoardModalProps = {
  boardUid: string;
} & ModalProps;

export function ShareBoardModal({ boardUid, closeModal }: ShareBoardModalProps) {
  const { t } = useTranslation();
  const [copied, setCopied] = useState(false);

  const shareUrl = `https://retroboard.net/board/${boardUid}`;

  const handleCopy = async () => {
    await navigator.clipboard.writeText(shareUrl);
    setCopied(true);
  };

  return (
    <div className="box">
      <p className="title is-4">{t("modal.share.title")}</p>
      <p className="subtitle">{t("modal.share.subtitle")}</p>
      <div className="field has-addons">
        <div className="control is-expanded">
          <input className="input" type="text" readOnly value={shareUrl} />
        </div>
        <div className="control">
          <Button color={copied ? "success" : "info"} onClick={handleCopy}>
            <Icon>
              <i className={copied ? "icon-ok" : "icon-clone"} aria-hidden="true"></i>
            </Icon>
            <span>{copied ? t("modal.share.copied") : t("modal.share.copy")}</span>
          </Button>
        </div>
      </div>
      <Button className="is-ghost has-text-info" onClick={closeModal}>{t("cancel")}</Button>
    </div>
  );
}
